import React from 'react';
import { render } from 'react-dom';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import App          from './modules/App';
import Home         from './modules/Home';
import LandSearch	from './modules/land-for-sale/LandSearch';
import Masterplan   from './modules/land-for-sale/Masterplan';
import Precinctplan from './modules/land-for-sale/Precinctplan';
import Stageplan    from './modules/land-for-sale/Stageplan';
import Lotplan      from './modules/land-for-sale/Lotplan';
import HouseAndLand from './modules/house-and-land/HouseAndLand';
import HouseAndLandRedirect from './modules/house-and-land/HouseAndLandRedirect';
import Package      from './modules/house-and-land/Package';
import Location     from './modules/location/Location';
import NotFound     from './modules/NotFound';
import './index.css';

render((
	<Router history={browserHistory}>
		<Route path="/" component={App}>
			<IndexRoute component={Home}/>
			<Route path="/land-for-sale" component={Masterplan}/>
			<Route path="/land-for-sale/precinct/:precinct" component={Precinctplan}/>
			<Route path="/land-for-sale/stage/:stage" component={Stageplan}/>
			<Route path="/land-for-sale/lot/:lot" component={Lotplan}/>
			<Route path="/land-for-sale/search" component={LandSearch}/>
			<Route path="/house-and-land" component={HouseAndLand}/>
			<Route path="/house-and-land/package" component={HouseAndLandRedirect}/>
			<Route path="/house-and-land/package/:package" component={Package}/>
			<Route path="/location" component={Location}/>
			<Route path="*" component={NotFound} />
		</Route>
	</Router>
), document.getElementById('InSiteIntereactive'));



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/